document.addEventListener('DOMContentLoaded', function () {
  initRevelado();
  initCifras();
  initGaleriaProducto();
  initVariantesProducto();
});

// Selector de variantes propio: al cambiar una opción, actualiza precio,
// disponibilidad, botón de compra e imagen principal sin recargar la página.
function initVariantesProducto() {
  document.querySelectorAll('[data-mt-variantes-wrap]').forEach(function (wrap) {
    var compra = wrap.closest('[data-mt-producto-compra]');
    if (!compra) return;
    var productoRoot = compra.closest('[data-mt-producto]');
    var datosScript = compra.querySelector('[data-mt-variantes-datos]');
    if (!datosScript) return;

    var variantes;
    try {
      variantes = JSON.parse(datosScript.textContent);
    } catch (e) {
      return;
    }

    var selects = wrap.querySelectorAll('select[data-mt-opcion]');
    var form = compra.querySelector('form[data-type="add-to-cart-form"]');
    var inputId = form ? form.querySelector('.product-variant-id') : null;
    var submitButton = compra.querySelector('[id^="ProductSubmitButton-"]');
    var submitText = submitButton ? submitButton.querySelector('span') : null;
    var precioActual = compra.querySelector('[data-mt-precio-actual]');
    var precioAntes = compra.querySelector('[data-mt-precio-antes]');
    var badgeAgotado = compra.querySelector('[data-mt-agotado]');
    var galeriaPrincipal = productoRoot ? productoRoot.querySelector('[data-mt-galeria-principal]') : null;

    function opcionesSeleccionadas() {
      var valores = [];
      selects.forEach(function (s) {
        valores[parseInt(s.dataset.mtOpcion, 10)] = s.value;
      });
      return valores;
    }

    function encontrarVariante() {
      var actuales = opcionesSeleccionadas();
      return variantes.find(function (v) {
        return (
          v.opciones.length === actuales.length &&
          v.opciones.every(function (valor, i) { return valor === actuales[i]; })
        );
      });
    }

    function aplicarVariante(variante) {
      if (!variante) return;

      if (inputId) {
        inputId.value = variante.id;
        inputId.disabled = !variante.disponible;
      }
      if (submitButton) submitButton.disabled = !variante.disponible;
      if (submitText) submitText.textContent = variante.disponible ? 'Agregar al carrito' : 'Agotado';

      if (precioActual) precioActual.textContent = variante.precio;
      if (precioAntes) {
        if (variante.precio_antes) {
          precioAntes.textContent = variante.precio_antes;
          precioAntes.hidden = false;
        } else {
          precioAntes.hidden = true;
        }
      }
      if (badgeAgotado) badgeAgotado.hidden = variante.disponible;

      if (galeriaPrincipal && variante.imagen) {
        galeriaPrincipal.src = variante.imagen;
        galeriaPrincipal.alt = variante.imagen_alt || '';
      }
    }

    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        aplicarVariante(encontrarVariante());
      });
    });
  });
}

// Intercambia la imagen principal de la galería de producto al pulsar una miniatura.
function initGaleriaProducto() {
  document.querySelectorAll('[data-mt-galeria]').forEach(function (galeria) {
    var principal = galeria.querySelector('[data-mt-galeria-principal]');
    if (!principal) return;

    galeria.querySelectorAll('[data-mt-miniatura]').forEach(function (miniatura) {
      miniatura.addEventListener('click', function () {
        principal.src = miniatura.dataset.full;
        principal.alt = miniatura.dataset.alt || '';
        galeria.querySelectorAll('[data-mt-miniatura]').forEach(function (m) {
          m.classList.toggle('mt-activa', m === miniatura);
        });
      });
    });
  });
}

// Anima con opacidad + desplazamiento cualquier elemento .mt-reveal al entrar en pantalla.
function initRevelado() {
  var elementos = document.querySelectorAll('.mt-reveal');
  if (!elementos.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    elementos.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }

  var observador = new IntersectionObserver(
    function (entradas) {
      entradas.forEach(function (entrada) {
        if (entrada.isIntersecting) {
          entrada.target.classList.add('mt-visible');
          observador.unobserve(entrada.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  elementos.forEach(function (el) { observador.observe(el); });
}

// Cuenta hacia arriba los números marcados con [data-mt-cifra] cuando entran en pantalla.
function initCifras() {
  var cifras = document.querySelectorAll('[data-mt-cifra]');
  if (!cifras.length) return;

  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var observador = new IntersectionObserver(
    function (entradas) {
      entradas.forEach(function (entrada) {
        if (!entrada.isIntersecting) return;
        var el = entrada.target;
        observador.unobserve(el);

        var textoFinal = el.textContent.trim();
        var coincidencia = textoFinal.match(/[\d.,]+/);
        if (!coincidencia) return;

        if (reducido) return;

        var numeroFinal = parseFloat(coincidencia[0].replace(',', '.'));
        var prefijo = textoFinal.slice(0, coincidencia.index);
        var sufijo = textoFinal.slice(coincidencia.index + coincidencia[0].length);
        var decimales = coincidencia[0].includes('.') || coincidencia[0].includes(',')
          ? (coincidencia[0].split(/[.,]/)[1] || '').length
          : 0;

        var duracion = 1400;
        var inicio = null;

        function paso(marca) {
          if (inicio === null) inicio = marca;
          var progreso = Math.min((marca - inicio) / duracion, 1);
          var facilitado = 1 - Math.pow(1 - progreso, 3);
          var valorActual = (numeroFinal * facilitado).toFixed(decimales);
          el.textContent = prefijo + valorActual + sufijo;
          if (progreso < 1) requestAnimationFrame(paso);
          else el.textContent = textoFinal;
        }
        requestAnimationFrame(paso);
      });
    },
    { threshold: 0.4 }
  );

  cifras.forEach(function (el) { observador.observe(el); });
}
